var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    width: "0.63em",
    height: "1em",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M319 704h7q67 0 110.5-44T480 548V167q0-70-44.5-118.5T326 0h-7q-32 0-61.5 13t-51 35.5t-34 53.5t-12.5 65v381q0 67 45.5 111.5T319 704zm-95-537q0-43 28-73t67-30h7q39 0 64.5 29.5T416 167v381q0 41-24.5 66.5T326 640h-7q-28 0-49.5-11.5T236 596t-12-48V167zm384 185q-13 0-22.5 9.5T576 384v133q0 143-51.5 213T368 800h-95q-38 0-69-9t-52.5-24t-37.5-37.5T88.5 683t-15-53.5t-7.5-56t-2-56.5V384q0-13-9.5-22.5T32 352t-22.5 9.5T0 384v133q0 167 69.5 257T273 864h15v96H128q-13 0-22.5 9.5T96 992t9.5 22.5t22.5 9.5h384q13 0 22.5-9.5T544 992t-9.5-22.5T512 960H352v-96h16q41 0 76.5-8t72.5-31.5t63.5-61t43-100.5T640 517V384q0-7-2.5-12.5t-7-10t-10-7T608 352z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicIcon);
export default __webpack_public_path__ + "static/media/mic-icon.5564688b.svg";
export { ForwardRef as ReactComponent };